module.exports = __webpack_public_path__ + "static/media/donation.831ede1e.svg";